//
import ProviderModel from '@/models/Purchase/PchProvider'
import Service from '@/services/api/service'

//
export default class extends Service {
    
    //
    static model = ProviderModel
}
